<template>
  <div class="camsContainer">
    <div v-if="subPage == 'Event List'">
      <Events />
    </div>
    <div v-else>
      <Calendar />
    </div>
  </div>
</template>

<script>
import * as Constants from "../../js/constants";
import Calendar from "./eventsAndCommunications/Calendar.vue";
import Events from "./eventsAndCommunications/Events.vue";

export default {
  props: ['subPage'],
  components: {
    Events,
    Calendar
  },
  data() {
    return {
      selectedItem: Constants.INCIDENTS,
      headerName: Constants.EVENTSANDCOMMUNICATIONS,
      filters: [],
      tableData: [],
      search: "",
      cardInfo: Constants.DEFAULT_CARD_INFO
    };
  },
  created() {
    this.performSearch("Richard").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData);
    });
  },
  methods: {
    performSearch(data) {
      this.search = data
      let url = `https://2r7ags60v2.execute-api.us-east-2.amazonaws.com/stage/nautica2/incidents`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `GET`,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            console.log("Search Data", data);
            this.tableData = data.data
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>